import MemoItem from "./MemoItem";
import React, { Fragment } from "react";

const MemoList = ({ memoData, saveMemo }) => {
  return (
    <Fragment>
      {memoData.map((m, index) => (
        <MemoItem key={index} m={m} index={index} saveMemo={saveMemo} />
      ))}
    </Fragment>
  );
};

export default MemoList;
